// /**
//  * Center - edit
//  */

// React
import React, { useEffect, useState } from 'react';

import { connect } from 'react-redux';
import { compose } from 'redux';
import { Store } from '../../../redux/reducers';

// react hook form
import { useForm } from 'react-hook-form';

// UI
import {
  TextField,
  Grid,
  Button,
  CardHeader,
  CardContent,
  Card,
  Paper,
  Typography,
} from '@material-ui/core';

import { makeSelectList } from '../selectors';

import { getCentersAction, updateCenterActions } from '../actions';

import { createStructuredSelector } from 'reselect';

import { removeEmptyValueObject } from '../../../utils/helpers';
import useQuery from '../../../utils/hook/useQuery';

// Component
import MapPosition from './mapPosition';
import classes from './edit.module.scss';
import windowSize from '../../../utils/hook/useWindowResize';
import EditMobile from '../mobileView/components/edit';

// Type
import { Supervisor } from '../interfaces';
import { User } from '../../users/interfaces';
import { SelectorPropsDetail, PayloadUpdate } from '../interfaces';

type Props = {
  data: any;
  update: (body: any, callback: () => void) => void;
  close: () => void;
  partnerId: number;
  supervisorsList: Supervisor[];
};

type Inputs = {
  name: string;
  code: string;
  admin: object;
  phoneNumber: number;
  province: string;
  city: string;
  zipCode: string;
  address: string;
};

// const
const user = {
  id: 0,
  name: '',
  phoneNumber: '',
  emailAddress: '',
  role: 'NONE',
  status: 'REGISTERED',
} as User;

function Edit(props: Props) {
  const { register, handleSubmit, errors, setValue } = useForm<Inputs>({
    mode: 'onChange',
  });

  const [supervisorId, setSupervisorId] = useState(
    0 as number | undefined | null
  );
  const [openAutocomplete, setOpenAutocomplete] = React.useState(false);
  const [options, setOptions] = React.useState<User[]>([user]);
  const { filtersValues, setFiltersValues } = useQuery({
    page: 0,
    size: 10,
  });
  const [latLng, setLatLng] = useState({
    lat: null,
    lng: null,
  });
  const [isMob, setIsMob] = useState(false);
  const { width } = windowSize();
  useEffect(() => {
    getCenters();
  }, [props.match.params?.centerId]);

  // const dataInput = props.centersList?.find(
  //   center => center.id == props.match.params?.centerId
  // );
  useEffect(() => {
    if (width && width <= 480) {
      setIsMob(true);
    } else {
      setIsMob(false);
    }
  }, [width]);
  useEffect(() => {
    if (props.centersList[0]) {
      setValue('name', props.centersList[0]?.name);
      setValue('code', props.centersList[0]?.code);
      setValue('zipCode', props.centersList[0]?.zipCode);
      setValue('phoneNumber', props.centersList[0]?.phoneNumber);
      setValue('province', props.centersList[0]?.province);
      setValue('city', props.centersList[0]?.city);
      setValue('address', props.centersList[0]?.address);
      setLatLng({
        lat: props.centersList[0]?.lat,
        lng: props.centersList[0]?.lon,
      });
    }
  }, [props.centersList[0]]);

  React.useEffect(() => {
    if (!openAutocomplete) {
      setOptions([]);
    }
  }, [openAutocomplete]); // eslint-disable-line react-hooks/exhaustive-deps

  const getCenters = () => {
    const { page, size } = filtersValues;
    const { partnerId, warehousesId } = props.match.params;
    props.centersDispatch({
      ...removeEmptyValueObject(filtersValues),
      warehousesId: { equals: warehousesId },
      id: { equals: props.match.params?.centerId },
      partnerId: { equals: partnerId },
      page,
      size,
    });
  };

  const onSubmit = (data: Inputs) => {
    const { name, phoneNumber, zipCode, address, city, province, code } = data;
    const { partnerId } = props;
    const { id, type, status } = props.centersList[0];
    const { lat, lng } = latLng;

    props.updateCenterDispatch({
      body: {
        name: name.trim(),
        phoneNumber: phoneNumber.length > 0 ? phoneNumber : null,
        address,
        code,
        partnerId,
        id,
        city: city.trim(),
        province: province.trim(),
        zipCode,
        lat,
        lon: lng,
        supervisorId,
        status: 'ACTIVE',
      },
    });
  };

  return isMob ? (
    <EditMobile {...props} />
  ) : (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Grid
        style={{
          zIndex: 3,
          backgroundColor: 'white',
          position: 'fixed',
          top: '0',
          right: '71px',
        }}
        container
        direction="row"
        justify="space-between"
        alignItems="center"
      >
        <Paper
          elevation={1}
          style={{
            width: '100%',
            borderRadius: '0',
          }}
        >
          <div className={classes.headerBox}>
            <Typography variant="h6" component="h2">
              {`
ویرایش مرکز        `}
              <span> &nbsp; {props.centersList[0]?.id}</span>
            </Typography>
          </div>
        </Paper>
      </Grid>

      <Grid lg={12} md={12} container style={{ marginTop: '16px' }} spacing={4}>
        <Grid md={12} lg={12} item spacing={2}>
          <Grid md={12} lg={12} item>
            <Card
              className={classes.card}
              style={{ padding: '15px 0', marginTop: '-32px' }}
            >
              <CardHeader
                avatar={
                  <Grid>
                    <Typography
                      className={classes.typographyCards}
                      style={{ marginRight: '-25px' }}
                    >
                      اطلاعات مرکز
                    </Typography>
                  </Grid>
                }
              />

              <CardContent className={classes.cardContentOrder}>
                <Grid container lg={12} md={12} className={classes.cardContent}>
                  <Grid container item spacing={2} lg={9} md={9}>
                    <Grid container item xs={12} sm={4} md={4} lg={4}>
                      <div className={classes.item}>
                        <div style={{ width: '100%' }}>
                          <TextField
                            variant="outlined"
                            fullWidth
                            id="name"
                            name="name"
                            label="نام مرکز"
                            inputRef={register({
                              required: true,
                              minLength: 5,
                              maxLength: 25,
                            })}
                            error={errors.name && true}
                          />
                          {errors.name && errors.name.type === 'required' && (
                            <p className={classes.errorText}>
                              {'فیلد نام مرکز الزامیست'}
                            </p>
                          )}
                          {errors.name && errors.name.type === 'minLength' && (
                            <p className={classes.errorText}>
                              {'مقدار نام مرکز نباید کمتر از 5 کاراکتر باشد'}
                            </p>
                          )}
                          {errors.name && errors.name.type === 'maxLength' && (
                            <p className={classes.errorText}>
                              {'مقدار نام مرکز نباید بیشتر از 25 کاراکتر باشد'}
                            </p>
                          )}
                        </div>
                      </div>
                    </Grid>
                    <Grid container item xs={12} sm={4} md={4} lg={4}>
                      <div className={classes.item}>
                        <div style={{ width: '100%' }}>
                          <TextField
                            variant="outlined"
                            fullWidth
                            id="code"
                            name="code"
                            label="کد مرکز"
                            InputProps={{
                              readOnly: true,
                            }}
                            inputRef={register({
                              required: true,
                              minLength: 1,
                              maxLength: 50,
                            })}
                            error={errors.code && true}
                          />
                          {errors.code && errors.code.type === 'required' && (
                            <p className={classes.errorText}>
                              {'فیلد کد مرکز الزامیست'}
                            </p>
                          )}
                          {errors.code && errors.code.type === 'minLength' && (
                            <p className={classes.errorText}>
                              {'مقدار کد مرکز نباید کمتر از 1 کاراکتر باشد'}
                            </p>
                          )}
                          {errors.code && errors.code.type === 'maxLength' && (
                            <p className={classes.errorText}>
                              {'مقدار کد مرکز نباید بیشتر از 50 کاراکتر باشد'}
                            </p>
                          )}
                        </div>
                      </div>
                    </Grid>
                    <Grid container item xs={12} sm={4} md={4} lg={4}>
                      <div className={classes.item}>
                        <div style={{ width: '100%' }}>
                          <TextField
                            variant="outlined"
                            fullWidth
                            id="phoneNumber"
                            name="phoneNumber"
                            label="شماره تماس"
                            inputRef={register({
                              required: true,
                              minLength: 6,
                              maxLength: 15,
                              pattern: /^([+]+98|0)\d{5,10}$/g,
                            })}
                            error={errors.phoneNumber && true}
                          />
                          {errors.phoneNumber &&
                            errors.phoneNumber.type === 'required' && (
                              <p className={classes.errorText}>
                                {'فیلد شماره تماس الزامیست'}
                              </p>
                            )}
                          {errors.phoneNumber &&
                            errors.phoneNumber.type === 'pattern' && (
                              <p className={classes.errorText}>
                                {'فرمت فیلد شماره تماس صحیح نیست'}
                              </p>
                            )}
                          {errors.phoneNumber &&
                            errors.phoneNumber.type === 'minLength' && (
                              <p className={classes.errorText}>
                                {
                                  'مقدار شماره تماس نباید کمتر از 11 کاراکتر باشد'
                                }
                              </p>
                            )}
                          {errors.phoneNumber &&
                            errors.phoneNumber.type === 'maxLength' && (
                              <p className={classes.errorText}>
                                {
                                  'مقدار شماره تماس نباید بیشتر از 15 کاراکتر باشد'
                                }
                              </p>
                            )}
                        </div>
                      </div>
                    </Grid>
                    <Grid container item xs={12} sm={6} md={4} lg={4}>
                      <div className={classes.item}>
                        <div style={{ width: '100%' }}>
                          <TextField
                            variant="outlined"
                            fullWidth
                            id="city"
                            name="city"
                            label="شهر"
                            inputRef={register({
                              required: false,
                              minLength: 2,
                              maxLength: 20,
                            })}
                            InputProps={{
                              readOnly: true,
                            }}
                            error={errors.city && true}
                          />
                          {errors.city && errors.city.type === 'minLength' && (
                            <p className={classes.errorText}>
                              {'مقدار شهر نباید کمتر از 2 کاراکتر باشد'}
                            </p>
                          )}
                          {errors.city && errors.city.type === 'maxLength' && (
                            <p className={classes.errorText}>
                              {'مقدار شهر نباید بیشتر از 20 کاراکتر باشد'}
                            </p>
                          )}
                        </div>
                      </div>
                    </Grid>
                    <Grid container item xs={12} sm={6} md={4} lg={4}>
                      <div className={classes.item}>
                        <span className={classes.text}>
                          <TextField
                            variant="outlined"
                            fullWidth
                            id="province"
                            name="province"
                            label="استان"
                            inputRef={register({
                              required: false,
                              minLength: 2,
                              maxLength: 20,
                            })}
                            InputProps={{
                              readOnly: true,
                            }}
                            error={errors.province && true}
                          />
                          {errors.province &&
                            errors.province.type === 'minLength' && (
                              <p className={classes.errorText}>
                                {'مقدار استان نباید کمتر از 2 کاراکتر باشد'}
                              </p>
                            )}
                          {errors.province &&
                            errors.province.type === 'maxLength' && (
                              <p className={classes.errorText}>
                                {'مقدار استان نباید بیشتر از 20 کاراکتر باشد'}
                              </p>
                            )}
                        </span>
                      </div>
                    </Grid>
                    <Grid container item xs={12} sm={6} md={4} lg={4}>
                      <div className={classes.item}>
                        <div style={{ width: '100%' }}>
                          <TextField
                            variant="outlined"
                            fullWidth
                            id="zipCode"
                            name="zipCode"
                            label="کد پستی"
                            inputRef={register({
                              required: true,
                              minLength: 10,
                              maxLength: 10,
                              pattern: /^\d{10}$/g,
                            })}
                            error={errors.zipCode && true}
                          />
                          {errors.zipCode &&
                            errors.zipCode.type === 'required' && (
                              <p className={classes.errorText}>
                                {'فیلد کد پستی الزامیست'}
                              </p>
                            )}
                          {errors.zipCode &&
                            errors.zipCode.type === 'pattern' && (
                              <p className={classes.errorText}>
                                {'فرمت فیلد کد پستی صحیح نیست'}
                              </p>
                            )}
                          {errors.zipCode &&
                            errors.zipCode.type === 'minLength' && (
                              <p className={classes.errorText}>
                                {'مقدار کد پستی نباید کمتر از 10 کاراکتر باشد'}
                              </p>
                            )}
                          {errors.zipCode &&
                            errors.zipCode.type === 'maxLength' && (
                              <p className={classes.errorText}>
                                {'مقدار کد پستی نباید بیشتر از 10 کاراکتر باشد'}
                              </p>
                            )}
                        </div>
                      </div>
                    </Grid>
                    <Grid container item xs={12} sm={12} md={12} lg={12}>
                      <div className={classes.item}>
                        <div style={{ width: '100%' }}>
                          <TextField
                            variant="outlined"
                            fullWidth
                            id="address"
                            name="address"
                            label="آدرس"
                            inputRef={register({
                              required: true,
                              minLength: 10,
                              maxLength: 200,
                            })}
                            error={errors.address && true}
                          />
                          {errors.address &&
                            errors.address.type === 'required' && (
                              <p className={classes.errorText}>
                                {'فیلد آدرس الزامیست'}
                              </p>
                            )}
                          {errors.address &&
                            errors.address.type === 'minLength' && (
                              <p className={classes.errorText}>
                                {'مقدار آدرس نباید کمتر از 10 کاراکتر باشد'}
                              </p>
                            )}
                          {errors.address &&
                            errors.address.type === 'maxLength' && (
                              <p className={classes.errorText}>
                                {'مقدار آدرس نباید بیشتر از 200 کاراکتر باشد'}
                              </p>
                            )}
                        </div>
                      </div>
                    </Grid>
                  </Grid>
                  <Grid item container lg={3} md={3}>
                    {props.centersList[0] && (
                      <Grid container item xs={12} lg={12} md={12}>
                        <div style={{ width: '100%' }}>
                          <MapPosition
                            style={{
                              border: 'solid 2px gray',
                              borderRadius: '4px',
                              height: '240px',
                            }}
                            zoom={14}
                            center={{ lat: 35.6892, lng: 51.389 }}
                            position={latLng}
                            setLatlng={(latLng: { lat: number; lng: number }) => {
                              setLatLng(latLng);
                            }}
                          />
                        </div>
                      </Grid>
                    )}
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
        <Grid
          container
          lg={12}
          md={12}
          xs={12}
          spacing={2}
          style={{
            flexDirection: 'row-reverse',
            position: 'fixed',
            backgroundColor: '#D5DADD',
            bottom: '0',
            right: '0',
            padding: '15px',
            zIndex: 2,
          }}
        >
          <Grid
            container
            style={{
              marginLeft: '35px',
              marginTop: '-4px',
            }}
          >
            <Button
              variant="outlined"
              color="primary"
              size="medium"
              onClick={() => window.history.back()}
              style={{
                marginRight: 'auto',
              }}
              data-cy="cancelBtn"
            >
              {'انصراف'}
            </Button>
            <Button
              type="submit"
              size="medium"
              data-cy="saveBtn"
              autoFocus
              variant="contained"
              color="primary"
              style={{
                marginRight: '14px',
                marginLeft: '120px',
              }}
            >
              ذخیره تغییرات
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </form>
  );
}

const mapStateToProps = createStructuredSelector<Store, SelectorPropsDetail>({
  centersList: makeSelectList(),
});

function mapDispatchToProps(dispatch: Function) {
  return {
    centersDispatch: (payload: Object) => dispatch(getCentersAction(payload)),
    updateCenterDispatch: (payload: PayloadUpdate) =>
      dispatch(updateCenterActions(payload)),
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(withConnect)(Edit);
